module.exports = __webpack_public_path__ + "img/uy.a3edc19b.svg";